import React from 'react';
import { Link } from 'react-router-dom';
import { Crosshair, Mail } from 'lucide-react';
import { CONTACT_INFO, NAV_LINKS } from '../mock';

const Footer = () => (
  <footer className="relative bg-[#060608] border-t border-white/5 pt-16 pb-8">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-5">
            <span className="flex items-center justify-center w-9 h-9 rounded-full border border-[#e11d2a]/70">
              <Crosshair className="w-5 h-5 text-[#e11d2a]" strokeWidth={1.5} />
            </span>
            <span className="font-display leading-none">
              <span className="block text-[#e11d2a] tracking-[0.22em] text-[15px]">PRECISION</span>
              <span className="block text-white/90 tracking-[0.34em] text-[11px] font-light">ANALYTICS</span>
            </span>
          </div>
          <p className="text-white/50 text-sm leading-relaxed max-w-md">
            We use our unique technology to measure the metrics that matter — delivering objective, accurate and unbiased insight into how consumers experience mobile networks across international markets.
          </p>
        </div>
        <div>
          <h4 className="text-white/90 text-sm font-medium tracking-widest uppercase mb-5">Navigate</h4>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}><a href={l.to} className="text-white/50 hover:text-white text-sm transition-colors">{l.label}</a></li>
            ))}
            <li><Link to="/contact" className="text-white/50 hover:text-white text-sm transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white/90 text-sm font-medium tracking-widest uppercase mb-5">Get in touch</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-2 text-white/50 text-sm"><Mail className="w-4 h-4 text-[#e11d2a]" /> {CONTACT_INFO.email}</li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-white/30 text-xs">© {new Date().getFullYear()} Precision Analytics LTD. All rights reserved.</p>
        <p className="text-white/30 text-xs">In the landscape of extinction, precision is next to godliness.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
